import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ViolationDetailResponse } from '@/types/apps/violation-detail.type';

import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ViolationDetailServiceInterface {}

type ViolationDetailGraphQLListResponse =
    GqlListResponse<ViolationDetailResponse>;

export class ViolationDetailGraphQLService
    extends BaseService
    implements ViolationDetailServiceInterface
{
    public getEntityName(): string {
        return 'violationDetail';
    }

    public getFields(): Record<string, any> {
        return {
            description: true,
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            deviceGroupId: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            severityLevelId: true,
            solution: true,
            violationTypeId: true,

            // deviceGroup: {
            //     code: false,
            //     id: false,
            //     name: false,
            //     deviceType: {
            //         devices: {
            //             customerId: false,
            //         },
            //     },
            //     deviceTypeCode: false,
            // },
            violationType: {
                code: true,
                id: true,
                name: true,
            },
        };
    }

    public async index(
        query: string
    ): Promise<ViolationDetailGraphQLListResponse> {
        return this.fetchGqlList<ViolationDetailGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('violationDetail', {
            userId: this.getQueryById(),
        });
    }
}
